import styles from '../Style/FeaturesModal.module.scss';
import { featuresLinks } from './featuresLinks';

type FeaturesNavigationProps = {
  activeLink: string;
  onLinkClick: (slug: string) => void;
};

export function FeaturesNavigation({ activeLink, onLinkClick }: FeaturesNavigationProps) {
  return (
    <div className={styles.listNavigation}>
      {featuresLinks.map((link, index) => (
        <a
          key={`features-link-${index}`}
          className={`${activeLink === link.slug ? styles.active : ''}`}
          href={`#${link.slug}`}
          onClick={(e) => {
            e.preventDefault();
            onLinkClick(link.slug);
          }}
        >
          {link.text}
        </a>
      ))}
    </div>
  );
}
